import React from 'react';
export default function NavRedes() {
  return <nav className="social-links" aria-label="Redes sociales">
        <a href="https://www.instagram.com/boca_de_sapo/" target="_blank" rel="noopener noreferrer">Instagram ↗</a>
        <a href="https://www.facebook.com/BOCADESAPO-113630765327065/" target="_blank" rel="noopener noreferrer">Facebook ↗</a>
        <a href="https://twitter.com/BocadSapo" target="_blank" rel="noopener noreferrer">X ↗</a>
        <a href="https://www.youtube.com/channel/UCTg_A-oBBP6hSlYoGgGPXdw" target="_blank" rel="noopener noreferrer">YouTube ↗</a>
        <a href="http://www.pinterest.com/bocadesapo/" target="_blank" rel="noopener noreferrer">Pinterest ↗</a>
    </nav>;
}
